<template>
  <v-layout wrap class="wrapper">
    <span>
      <customise-modal
        :visible-fields="visibleFields"
        :all-fields="allFields"
        :event-id="eventId"
        @fieldsChanged="onFieldsChanged"
      />
      <filters-modal
        :attendee-fields="attendeeFields"
        :schema="getSchema()"
        :categories="categories"
        :extra-modules="extraModules"
        :initial-filters="initialFilters"
        @filtersChanged="onFiltersChanged"
      />
    </span>
    <v-flex grow>
      <v-layout class="search_container">
        <v-icon class="icon-search" color="#0277bd" :size="15" @click="focusSearchInput">
          search
        </v-icon>
        <input
          ref="searchInput"
          v-model="filters.quickSearch"
          placeholder="Quick search"
          class="search_input_field"
        >
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { debounce } from 'lodash'

import CustomiseModal from './customise-modal'
import FiltersModal from './filters-modal'
import { createAttendeeSchema } from '../../../utils'

const onQuickSearchChange = vueInstance =>
  debounce(quickSearch => {
    vueInstance.$emit('quickSearch', quickSearch)
  }, 350)

export default {
  name: 'table-filters',
  components: {
    CustomiseModal,
    FiltersModal,
  },
  props: {
    initialFilters: Object,
    visibleFields: Array,
    allFields: Array,
    attendeeFields: Object,
    categories: Array,
    extraModules: Object,
    eventId: String,
  },
  data() {
    return {
      filters: {
        quickSearch: this.initialFilters.quickSearch,
      },
      onQuickSearchChange: onQuickSearchChange(this),
    }
  },
  watch: {
    filters: {
      handler(val) {
        this.onQuickSearchChange(val)
      },
      deep: true,
    },
  },
  methods: {
    onFiltersChanged(val) {
      const { quickSearch, ...filters } = val
      this.$emit('filters', filters)
    },
    getSchema() {
      return createAttendeeSchema(this.attendeeFields)
    },
    focusSearchInput() {
      this.$refs.searchInput.focus()
    },
    onFieldsChanged(visibleFields) {
      this.$emit('update:visibleFields', visibleFields)
    },
  },
}
</script>

<style scoped>
.wrapper {
  margin: 0 0 2px 0;
  padding: 0px;
  background-color: #f5f5f5;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
@media (min-width: 800px) {
  .wrapper {
    min-width: 450px;
    height: 48px;
  }
}
.icon-search {
  margin-right: 8px;
}
.search_container {
  height: 100%;
  padding: 0 15px;
}
@media (max-width: 800px) {
  .search_container {
    height: 48px;
  }
  .wrapper {
    display: flex;
    flex-direction: column;
    background-color: #fff;
  }
  .wrapper > * > * {
    background-color: #f5f5f5;
    width: 100%;
  }
  .wrapper span > div:first-child {
    margin-right: 2px;
    border-top-left-radius: 8px;
  }
  .wrapper span > div:last-child {
    border-top-right-radius: 8px;
  }
  .wrapper span {
    border-radius: 8px 8px 0 0 !important;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 2px;
  }
}

.search_input_field {
  width: 100%;
  height: 100%;
  font-family: 'Source Sans Pro';
  font-size: 16px;
  line-height: 1.25;
}

.search_input_field:focus {
  outline: none;
}

.search_input_field::placeholder {
  font-family: 'Source Sans Pro';
  color: #979797;
  font-size: 16px;
  line-height: 1.25;
}

.search_input_field::-moz-placeholder {
  line-height: 48px;
}
</style>
